export const DEFAULT_HEAD_TAGS = {
  description: 'ディズニーマニアの知識共有サイト',
  ogType: 'website',
  imageName: 'site-image.png',
  ogLocale: 'ja_JP',
  twitterCard: 'summary_large_image',
  twitterSite: '@Axel_1864',
};

export const SUB_SITE_IMAGES = {
  articles: 'site-image-articles.png',
  inquiry: 'site-image-inquiry.png',
  specialMap: 'site-image-special-map.png',
};

// If you change these info, don't forget to change cloudfront
export const PAGE_DESCRIPTIONS = {
  main: '隠れミッキー、バックグラウンドストーリーなど、ディズニーのマニアックな知識を地図上で共有できるサイト',
  articles: '全ての投稿を一覧で確認、または記事の検索ができます。',
  login: 'ログインすると、新しいトリビアを投稿できるようになります。',
  inquiry: 'サイト管理者へのお問い合わせはこちらです。',
  specialMaps: 'ユーザーによって作成されたオリジナルマップを一覧で確認できます。',
  specialMapNew: '新規でオリジナルマップを作成します。',
};
